<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加物品</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>

            <el-col :span="12" class="item">
              <el-form-item label="选择物品" required prop="waresName">
                <el-input v-model="addForm.waresName" placeholder="选择物品" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getWares"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearWares"></el-button>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="物品入库数量" required prop="count">
                <el-input v-model="addForm.count" placeholder="输入入库数量" style=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="过期时间" required prop="expiresTime">
                <el-date-picker
                    v-model="addForm.expiresTime"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="过期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <SelectWares ref="mySelectWares" v-show="showModalWares"
                 v-on:closeWares="showModalWares=false"
                 v-on:setWares="setWares"></SelectWares>

  </div>
</template>

<script>

import { timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";

import SelectWares from "./SelectWares";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      showModalWares:false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        waresCode:'',
        waresName:'',
        row:'',
        count:'',
        expiresTime:'',

      },

      institutionCode:'',


      rules:{
        waresName:[
          { required: true, message: '请选择物品', trigger: 'blur' },
          { required: true, message: '请选择物品', trigger: 'change' },
        ],
        count:[
          { required: true, message: '请输入入库数量', trigger: 'blur' },
        ],

      }


    }
  },
  components:{
    SelectWares
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getWares(){
      this.showModalWares = !this.showModalWares;
      this.$refs.mySelectWares.init();
    },
    setWares(row){
      this.addForm.waresCode = row.waresCode;
      this.addForm.waresName = row.name;
      this.addForm.row = row;
    },
    clearWares(){
      this.addForm.waresCode = '';
      this.addForm.waresName = '';
      this.addForm.row = '';
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },


    addSubmit(){

      let r = this.addForm.row;
      r.count=this.addForm.count;
      r.expiresTime = this.addForm.expiresTime;

      this.$emit("getWares",r);

      this.$emit("closeAdd");
      this.$emit("getList");

    },


  }
}


</script>
<style lang="scss" scoped>

</style>
